var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebookIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 19,
    viewBox: "0 0 11 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.396 19H6.396V10.99H10L10.396 7.01H6.396V5C6.396 4.73478 6.50136 4.48043 6.68889 4.29289C6.87643 4.10536 7.13078 4 7.396 4H10.396V0H7.396C6.06992 0 4.79815 0.526784 3.86047 1.46447C2.92278 2.40215 2.396 3.67392 2.396 5V7.01H0.396L0 10.99H2.396V19Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookIcon);
export default __webpack_public_path__ + "static/media/facebook_icon.86252c37fe289ba913fb898b21063e6c.svg";
export { ForwardRef as ReactComponent };